const SYMBOL_FONTS = ["Wingdings", "Wingdings 2", "Wingdings 3", "Webdings", "Symbol"];

const BULLET_BY_CODEPOINT: Record<string, string> = {
  "": "▪",
  "": "◆",
  "": "➢",
  "": "✓",
};

const DEFAULT_BULLET = "•";

const BULLET_TEXT_GAP = "0.5em";

const isSymbolFont = (fontFamily: string) =>
  SYMBOL_FONTS.some((font) => fontFamily.trim().replace(/^["']|["']$/g, "").toLowerCase() === font.toLowerCase());

const toBullet = (content: string) => {
  const glyph = content.split("").find((char) => BULLET_BY_CODEPOINT[char]);
  return glyph ? BULLET_BY_CODEPOINT[glyph] : DEFAULT_BULLET;
};

export const normalizeDocxSymbolBullets = (styleEl: HTMLElement, fallbackFontFamily: string) => {
  styleEl.querySelectorAll("style").forEach((sheet) => {
    const rules = sheet.sheet?.cssRules;
    if (!rules) return;

    for (const rule of Array.from(rules)) {
      if (!(rule instanceof CSSStyleRule)) continue;

      const fontFamily = rule.style.getPropertyValue("font-family");
      const content = rule.style.getPropertyValue("content");
      if (!fontFamily || !isSymbolFont(fontFamily)) continue;
      // Numbered markers interpolate a counter; only static glyphs are bullets.
      if (content.includes("counter(")) continue;

      rule.style.setProperty("font-family", fallbackFontFamily);
      rule.style.setProperty("content", `"${toBullet(content)}"`);
      // Word separated marker from text with a tab, which the rewrite above drops.
      rule.style.setProperty("display", "inline-block");
      rule.style.setProperty("margin-right", BULLET_TEXT_GAP);
    }
  });
};
